<template>
  <div>
    <childLogo></childLogo>
    <el-row style="min-height: 650px">
      <el-col :span="4">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="16">
        <div class="grid-content">
          <div v-bind="article" class="article-title">
            {{ article === undefined ? "" : article.title }}
          </div>
          <!--  <div
            v-bind="article"
            class="article-author"
          >{{article === undefined || article === '' ? '佚名' : article.author}}</div> -->
          <div style="text-align: left" v-html="articleData.content"></div>
          <div
            style="color: blue; cursor: pointer"
            v-if=" detailFile "
            @click="download(detailFile.id)"
          >
            附件： {{detailFile.fileName}}
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
export default {
  name: "Detail",
  components: {
    ChildLogo: ChildLogo,
  },
  watch: {
    articleId: function () {
      this.handleArticle();
      this.handleArticleData();
      this.article = undefined;
      this.detailFile = "";
      this.articleData = { content: "" };
    },
  },
  data() {
    return {
      articleId: undefined,
      article: undefined,
      detailFile: "",
      articleData: {
        content: "",
      },
    };
  },
  created() {
    this.articleId = this.$route.query.id;
  },
  methods: {
    handleArticle() {
      var api = this.siteURL + "/actuator/article/list?id=" + this.articleId;
      this.axios.get(api, {}).then((response) => {
        this.article = response.data.rows[0];
         this.getFile(response.data.rows[0].coverId);
      });
    },
    getFile(coverId) {
      var api = this.systemURL + "/actuator/storage/" + coverId;
      this.axios.get(api, {}).then((response) => {
        this.detailFile = response.data.data;
      });
    },
    handleArticleData() {
      var api =
        this.siteURL + "/actuator/data/list?articleId=" + this.articleId;
      this.axios.get(api, {}).then((response) => {
        this.articleData = response.data.rows[0];
      });
    },
    goToSignUp() {
      this.$router.replace("/signUp");
    },
    download(coverId) {
      if (coverId === undefined || coverId === null) {
        this.$message("没有文件可下载");
        return;
      }
      var api = this.siteURL + "/actuator/storage/" + coverId;
      this.axios.get(api, {}).then((response) => {
        let fileUrl = response.data.data.fileName;
        var downUrl = this.siteURL + "/actuator/storage/download/" + coverId;
        this.axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
        this.axios({
          method: "post",
          url: downUrl,
          responseType: "blob",
        }).then((res) => {
          let data = res.data;
          if (!data) {
            return;
          }
          const blob = new Blob([data]);
          // 其他非IE内核支持H5的浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileUrl);
          document.body.appendChild(link);
          link.click();
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
  min-height: 600px;
}
.article-title {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
}
.article-author {
  width: 95%;
  height: 60px;
  line-height: 60px;
  text-align: right;
  font-size: 16px;
  margin-right: 30px;
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Detail.vue